export const shouldEnableEmbedProtocol = (url: URL) =>
  url.pathname.replace(/\/+$/, "") === "/embed" ||
  url.searchParams.get("embed") === "1";
